import { FC } from 'react';

import { IconButton, IconButtonProps } from '@mui/material';

import { ReactComponent as CloseIcon } from 'assets/icons/CloseIcon.svg';

import scssVariables from 'styles/sass-variables.module.scss';

export const CloseButton: FC<IconButtonProps> = (props) => {
  return (
    <IconButton disableRipple {...props}>
      <CloseIcon color={scssVariables.text_grey} />
    </IconButton>
  );
};
